import React from 'react';
import './ImageLoaderSkeleton.css'; // Assuming you will create a separate CSS file

const ImageLoaderSkeleton = () => {
  return (
    <div className="imgGenericloader">
      <div className="imgGenericloader-inner"></div>
    </div>
  );
};

export default ImageLoaderSkeleton;